import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { cx } from '../cx.js';

export interface StatBlockProps {
  label: string;
  value: ReactNode;
  icon?: LucideIcon;
  /** colore del valore: stato mai affidato al solo colore, l'icona e l'etichetta lo accompagnano */
  tone?: 'neutral' | 'success' | 'warning' | 'error';
  hint?: string;
  className?: string;
}

const toni = { neutral: 'text-ink', success: 'text-success', warning: 'text-warning', error: 'text-error' } as const;

/** Un numero con etichetta, per i riepiloghi (collegati, in sala, sopra soglia…). */
export function StatBlock({ label, value, icon: Icon, tone = 'neutral', hint, className }: StatBlockProps) {
  return (
    <div className={cx('flex flex-col gap-0.5 min-w-0', className)} title={hint}>
      <dt className="t-body-small text-ink-muted inline-flex items-center gap-1">
        {Icon && <Icon aria-hidden size={14} strokeWidth={1.75} />}
        {label}
      </dt>
      <dd className={cx('t-title-2 tabular-nums', toni[tone])}>{value}</dd>
      {hint && <span className="sr-only">{hint}</span>}
    </div>
  );
}

/** Fila di StatBlock, da 2 a 5 colonne. */
export function StatRow({ children, className }: { children: ReactNode; className?: string }) {
  return <dl className={cx('grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4', className)}>{children}</dl>;
}
